module.exports = __webpack_public_path__ + "img/keyboard_arrow_right-24px.7e114a71.svg";